import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import Col from "react-bootstrap/esm/Col";
import Container from "react-bootstrap/esm/Container";
import Row from "react-bootstrap/esm/Row";
import { useDispatch, useSelector } from "react-redux";
import TableComponent, {
  NoRecordTemplate,
} from "../../../Services/TableComponent";
import { WebService } from "../../../Services/WebService";
import "../../Static/Static.css";
import AddEditComponent from "./AddEditComponentTemplate";
import { ActionPermission } from "../../PageInfo";
import ActionButton from "../../../Services/ActionButton";
import SnackbarComponent from "../../../Services/SnackbarComponent";
import DeleteConfirmAlert from "../../../Services/AlertComponent";
import { StandardConst } from "../../../Services/StandardConst";
import { findWhere, where } from "underscore";
import DisplayNumberFormatComponent from "../../../Services/DisplayNumberFormatComponent";
import { Button, Divider, Grid, IconButton } from "@mui/material";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import { WSSuccessAlert } from "../../../Services/WSAlert";
const SalaryTemplateComponent = forwardRef(({}, ref) => {
  const deleteConfirmAlertRef = useRef();
  const refSnackbar = useRef();
  var dispatch = useDispatch();
  var [data, setData] = useState([]);
  var afterRender = useRef(false);
  const fetchComponentList = async () => {
    var res = await WebService({
      dispatch,
      endPoint: "SalaryTemplateComp/Fetch",
    });
  

      // Sort by UpdateOrder, items with 0 order go to end
    res = res.sort((a, b) => {
      // First separate by IsEarning
      if (a.IsEarning !== b.IsEarning) return b.IsEarning - a.IsEarning;
      
      // Then sort by UpdateOrder
      if (a.UpdateOrder === 0 && b.UpdateOrder === 0) return 0;
      if (a.UpdateOrder === 0) return 1;
      if (b.UpdateOrder === 0) return -1;
      return a.UpdateOrder - b.UpdateOrder;
    });
    
    
    setData(res);
  };
  //#region Parent Data Id store
  console.log(data);
  const [templateId, setTemplateId] = useState(null);
  useImperativeHandle(ref, () => ({
    fetchByParent: setTemplateId,
  }));
  //#endregion
  const [permission] = useState({
    ManageAdd: ActionPermission("Salary - Component Add"),
    ManageEdit: ActionPermission("Salary - Component Edit"),
    // ManageDelete: ActionPermission("Roles - Delete"),
  });

  const onDelete = async (TemplateComponentId) => {
    await WebService({
      endPoint: `SalaryTemplateComp/Delete/${TemplateComponentId}`,
      method: "DELETE",
      dispatch,
    });
    refSnackbar.current.setOpenSnackBar();
    await fetchComponentList();
  };

  // Adde Functinality for re arrange row (UP/Down arrow)========

//   // Move Up/Down functions
//   const moveRow = async (index, direction, isEarning) => {
//     const filteredData = where(
//       templateId === null ? data : where(data, { TemplateId: templateId }),
//       { IsEarning: isEarning ? 1 : 0 }
//     );

//     if (
//       (direction === "up" && index === 0) ||
//       (direction === "down" && index === filteredData.length - 1)
//     ) {
//       return; // Cannot move first item up or last item down
//     }

//     const newIndex = direction === "up" ? index - 1 : index + 1;
//     const newData = [...data];
    
//     // Find actual indices in main data array
//     const currentItemId = filteredData[index].TemplateComponentId;
//     const targetItemId = filteredData[newIndex].TemplateComponentId;
    
//     const currentActualIndex = newData.findIndex(
//       (item) => item.TemplateComponentId === currentItemId
//     );
//     const targetActualIndex = newData.findIndex(
//       (item) => item.TemplateComponentId === targetItemId
//     );

//     // Swap items
//     [newData[currentActualIndex], newData[targetActualIndex]] = [
//       newData[targetActualIndex],
//       newData[currentActualIndex],
//     ];

//     setData(newData);
// console.log(newData,'after swap');
//     // Optional: Update order in backend
//     try {
//       // await WebService({
//       //   endPoint: "SalaryTemplateComp/UpdateOrder",
//       //   method: "POST",
//       //   dispatch,
//       //   body: {
//       //     items: newData.map((item, idx) => ({
//       //       TemplateComponentId: item.TemplateComponentId,
//       //       DisplayOrder: idx,
//       //     })),
//       //   },
//       // });

//       await WebService({
//         endPoint: "SalaryTemplateComp/UpdateOrder",
//         method: "POST",
//         dispatch,
//         body: {
//           items: newData.map((item, idx) => ({
//             TemplateComponentId: item.TemplateComponentId,
//             DisplayOrder: idx,
//           })),
//         },
//       });

//     } catch (error) {
//       console.error("Error updating order:", error);
//       // Revert on error
//       await fetchComponentList();
//     }
//   };

// Move Up/Down functions with complete reordering
  const moveRow = async (currentItem, direction, isEarning) => {
    // Get filtered data for current earning/deduction type
    let filteredData = where(
      templateId === null ? data : where(data, { TemplateId: templateId }),
      { IsEarning: isEarning ? 1 : 0 }
    );

    // Find current index in filtered data
    const currentIndex = filteredData.findIndex(
      (item) => item.TemplateComponentId === currentItem.TemplateComponentId
    );

    // Check boundaries
    if (
      (direction === "up" && currentIndex === 0) ||
      (direction === "down" && currentIndex === filteredData.length - 1)
    ) {
      return;
    }

    // Calculate new index
    const newIndex = direction === "up" ? currentIndex - 1 : currentIndex + 1;
    
    // Remove item from current position
    const [movedItem] = filteredData.splice(currentIndex, 1);
    
    // Insert at new position
    filteredData.splice(newIndex, 0, movedItem);

    // Create update array with all items in new order
    const updateOrderArray = filteredData.map((item, index) => ({
      TemplateComponentId: item.TemplateComponentId,
      UpdateOrder: index + 1, // 1-based ordering
      TemplateId: item.TemplateId,
      IsEarning: item.IsEarning
    }));

    try {
      // Send all items to backend for bulk update
      await WebService({
        endPoint: "SalaryTemplateComp/UpdateOrderBulk",
        method: "POST",
        dispatch,
        body: {
          items: updateOrderArray
        },
      });

      // Refresh data after successful update
      await fetchComponentList();
      
      refSnackbar.current.setOpenSnackBar("Order updated successfully");
      // WSSuccessAlert("Order updated successfully");
    } catch (error) {
      console.error("Error updating order:", error);
      refSnackbar.current.setOpenSnackBar("Error updating order");
    }
  };


  // ===========================End =================================

  const addEditModalRef = useRef();
  useEffect(() => {
    if (afterRender.current === false) {
      fetchComponentList();
    }
    afterRender.current = true;
  }, []);
  const companyInfo = useSelector((s) => s.auth.CompanyInfo ?? {});
  const [companyCurrentSymbol, setCompanyCurrencySymbol] = useState("");

  const fetchCurrentSymbolOfCompany = async () => {
    const companyInformation = await WebService({
      endPoint: `CommonUtility/Edit/companyinformation?CompanyId=${companyInfo.CompanyId || 0}`,
      dispatch,
    }).then((c) => (c.length > 0 ? c[0] : {}));
    const currencyInformation = await WebService({
      endPoint: `CommonUtility/Edit/staticcurrency?CurrencyId=${companyInformation.CurrencyId || 0}`,
      dispatch,
    }).then((c) => (c.length > 0 ? c[0] : {}));
    setCompanyCurrencySymbol(currencyInformation.Symbol);
  };

  useEffect(() => {
    fetchCurrentSymbolOfCompany();
  }, [companyInfo.CompanyId, companyCurrentSymbol])
  const fnEdit = async (id) =>
    await addEditModalRef.current.openModal(id || 0, templateId);
  var columns = [
    {
      Text: "Template Name",
      Value: "TemplateName",
      isVisiable: templateId === null,
    },
    {
      Text: "Salary Head",
       exportValue: (dr) => {
    let result = `${dr.EarningOrDeductionName} (`;

    if (dr.CalculationMethodId === 1) {
      if (dr.IsDependentOnCTC === 1) {
        result += `${dr.NumberOrAmount ?? 0}% of CTC`;
      } else {
        const depName =
          findWhere(data, {
            TemplateComponentId: dr.DependentOnComponentId,
          })?.EarningOrDeductionName ?? "";

        result += `${dr.NumberOrAmount ?? 0}% of ${depName}`;
      }
    } else {
      // Flat amount case
      result += `${companyCurrentSymbol}${dr.NumberOrAmount ?? 0}`;
    }

    result += ")";
    return result;
  },
      // exportValue: 
      render: (dr) => (
        <>
          <span>{`${dr.EarningOrDeductionName} (`}</span>
          {dr.CalculationMethodId === 1 ? (
            dr.IsDependentOnCTC === 1 ? (
              <span>{`${dr.NumberOrAmount ?? 0}% of CTC`}</span>
            ) : (
              <span>
                {`${dr.NumberOrAmount ?? 0}% of ${
                  findWhere(data, {
                    TemplateComponentId: dr.DependentOnComponentId,
                  })?.EarningOrDeductionName
                }`}
              </span>
            )
          ) : (
            <>
              <DisplayNumberFormatComponent Number={dr.NumberOrAmount} Currency={companyCurrentSymbol}/>
            </>
          )}
          <span>{")"}</span>
        </>
      ),
    },
    {
      Text: "Action",
      key: "TemplateComponentId",
      cssClass: "text-center",
      style: { width: "200px", padding: "0px" },
      isVisiable: permission.ManageEdit,
      render: (dr) => (
        <>
        <ActionButton
            onClick={() => moveRow(dr, "up", dr.IsEarning === 1)}
            IconName="UpArrow"
            id="btnSalaryTemplateCompMoveUp"
            title="Move Up"
          />
          
          <ActionButton
            onClick={() => moveRow(dr, "down", dr.IsEarning === 1)}
            IconName="DownArrow"
            id="btnSalaryTemplateCompMoveDown"
            title="Move Down"
          />

         {/* <ActionButton
            onClick={(e) => {
              const key = e.currentTarget.closest("[data-key]")?.getAttribute("data-key");
              const row = e.currentTarget.closest("tr");
              const isEarning = row?.closest(".earnings-table") !== null;
              const tbody = row?.parentElement;
              const rowIndex = Array.from(tbody?.children || []).indexOf(row);
              moveRow(rowIndex, "up", isEarning);
            }}
            IconName="UpArrow"
            id="btnSalaryTemplateCompMoveUp"
          />
          
          <ActionButton
            onClick={(e) => {
              const key = e.currentTarget.closest("[data-key]")?.getAttribute("data-key");
              alert(key);
              const row = e.currentTarget.closest("tr");
              const isEarning = row?.closest(".earnings-table") !== null;
              const tbody = row?.parentElement;
              const rowIndex = Array.from(tbody?.children || []).indexOf(row);
              moveRow(rowIndex, "down", isEarning);
            }}
            IconName="DownArrow"
            id="btnSalaryTemplateCompMoveDown"
          /> */}
          <ActionButton
            onClick={(e) =>
              fnEdit(e.currentTarget.closest("[data-key]")?.getAttribute("data-key"))
            }
            disabled={!permission.ManageEdit}
            IconName="Edit"
            id="btnSalaryTemplateCompEdit"
          />

          <ActionButton
            onClick={(e) =>
              deleteConfirmAlertRef.current.confirmAlert(
                "Delete", //Confirm button text
                "Are You Sure", // Text if Alert
                "Do you want to delete " + MasterPageName, // Message of Alert
                e.currentTarget.closest("[data-key]")?.getAttribute("data-key") // Endpoint to hit for delete
              )
            }
            IconName="Delete"
            id="btnSalaryTemplateCompDelete"
          />
        </>
      ),
    },
  ];

  const MasterPageName = "Salary Template Component";
  const confirmMessage = MasterPageName + " Deleted successfully";
  return (
    <>
      <SnackbarComponent ref={refSnackbar} confirmMessage={confirmMessage} />
      <DeleteConfirmAlert
        ref={deleteConfirmAlertRef}
        confirmEvent={(v) => onDelete(v)}
      />
      <Container
        style={{
          backgroundColor: "#FFF",
          padding: "0px",
        }}
      >
        {templateId === null && (
          <Row className="mt-2">
            <Col
              xs={12}
              md={12}
              className="d-flex justify-content-center align-items-center"
            >
              <h4>Template Component</h4>
            </Col>
          </Row>
        )}
        <Row
          className="d-flex align-items-center"
          style={{
            backgroundColor: StandardConst.wsSecondaryColor,
            padding: "10px",
          }}
        >
          <Col md={6} className="col-5 text-center square border-end mb-1">
            <strong> Earnings</strong>
          </Col>
          <Col md={5} className="col-5 text-center bg-color:red">
            <strong>Deduction</strong>
          </Col>
          <Col md={1} className="col-2 text-center bg-color:red">
            {permission.ManageAdd && (
              <IconButton size="small" color="primary" onClick={() => fnEdit()}>
                <AddCircleIcon />
              </IconButton>
            )}
          </Col>
        </Row>
        <Grid container spacing={0.5} sx={{ pl: 0 }}>
          <Grid item className="col-6 earnings-table">
            <TableComponent
              columns={columns}
              noRecordCss="p-0"
              isSearchRequired={false}
              data={where(
                templateId === null
                  ? data
                  : where(data, { TemplateId: templateId }),
                { IsEarning: 1 }
              )}
              pageSize={0}
              IsAddButtonVisible={false}
              onAddEvent={() => fnEdit()}
            />
          </Grid>
          <Grid item className="col-6 deductions-table">
            <TableComponent
              columns={columns}
              noRecordCss="p-0"
              data={where(
                templateId === null
                  ? data
                  : where(data, { TemplateId: templateId }),
                { IsEarning: 0 }
              )}
              pageSize={0}
              // IsAddButtonVisible={permission?.ManageAdd}
              IsAddButtonVisible={false}
              isSearchRequired={false}
              onAddEvent={() => fnEdit()}
            />
          </Grid>
        </Grid>
      </Container>
      <AddEditComponent
        callBackEvent={() => fetchComponentList()}
        ref={addEditModalRef}
      ></AddEditComponent>
    </>
  );
});

export default SalaryTemplateComponent;
